<template>
  <div id="rect-area" >
    <canvas id="rect-canvas" v-bind:style="{'opacity': opacity}"></canvas>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

function convertToSphereCoords(lat, lon, sphere_radius) {
  return [Math.cos(lat * Math.PI / 180) * Math.cos(lon * Math.PI / 180) * sphere_radius,
          Math.cos(lat * Math.PI / 180) * Math.sin(lon * Math.PI / 180) * sphere_radius,
          Math.sin(lat * Math.PI / 180) * sphere_radius];

}

const THREE = require('three') // required peer dependency
const rects = [
  [[ 45.8182519, 8.826895 ],[ 45.4668, 9.1905 ]],
  [[ 50.93333, 6.95 ],[ 50.73438, 7.09549 ]],
  [[ 50.11092, 8.68213 ],[ 49.87283, 8.65119 ]],
  [[ 56.26, 5.0 ],[ 45.36, 16.5 ]],
  [[ 46.1182519, 15.326895 ],[ 44.3, 20.44 ]],
  [[ 53.7589938,-2.7051618],[ 53.7589938, -2.7051618 ]],
  [[50.4484,3.65428],[50.00908, 2.86457]],
  [],
  [[ 45.5, -9.0],[ 35, 3.0 ]],
  [],
  [],
  [],
  [],
  [],
]

export default {
  name: 'timeline',
  components: {

  },
  props: ['scene', 'camera'],
  watch: {
    factIndex: function(){
      if(this.factIndex>0){
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if(rects[this.factIndex-1].length>1){
          this.update();
          this.redraw();
        }
      }
    }
  },
  computed:{
    ...mapGetters(['facts', 'factIndex', 'detailedView']),
    opacity: function(){
      if(this.detailedView && this.factIndex>0 && rects[this.factIndex-1].length>1) return 1
      else return 0
    }
  },
  data() {
    return {
      pixelRatio: window.devicePixelRatio
    }
  },
  created: function(){
    for(let i=0; i<rects.length; i++){
      if(rects[i].length>1){
        const t = 0.3
        let minX = Math.min(rects[i][0][0],rects[i][1][0]) - t
        let maxX = Math.max(rects[i][0][0],rects[i][1][0]) + t
        let minY = Math.min(rects[i][0][1],rects[i][1][1]) - t
        let maxY = Math.max(rects[i][0][1],rects[i][1][1]) + t
        rects[i][0][0] = minX
        rects[i][0][1] = minY
        rects[i][1][0] = maxX
        rects[i][1][1] = maxY
      }
    }
    window.addEventListener('resize',
      ()=>{
        this.canvas.width = window.innerWidth * this.pixelRatio;
        this.canvas.height = window.innerHeight * this.pixelRatio;
        if(this.factIndex>0 && rects[this.factIndex-1].length>1){
          this.update();
          this.redraw()
        }
      },
    false);
  },
  methods: {
    update: function(){
        let coordinates = rects[this.factIndex-1]
        const radius = 10
        /*eslint-disable-next-line*/

        let p = convertToSphereCoords(Math.min(coordinates[0][0],coordinates[1][0]), Math.min(coordinates[0][1],coordinates[1][1]), radius)
        this.dummyObject.position.set(p[0], p[1], p[2])
        this.topLeft = this.get2DCoords(this.dummyObject, this.camera);

        /*eslint-disable-next-line*/
        p = convertToSphereCoords(Math.max(coordinates[0][0],coordinates[1][0]), Math.max(coordinates[0][1],coordinates[1][1]), radius)
        this.dummyObject.position.set(p[0], p[1], p[2])
        this.bottomRight = this.get2DCoords(this.dummyObject, this.camera);
        this.width = this.bottomRight.x-this.topLeft.x;
        this.height = this.bottomRight.y-this.topLeft.y;

    },
    get2DCoords: function (object, camera) {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const tempV = new THREE.Vector3();
      // get the position of the center of the cube
      object.updateWorldMatrix(true, false);
      object.getWorldPosition(tempV);

      // get the normalized screen coordinate of that position
      // x and y will be in the -1 to +1 range with x = -1 being
      // on the left and y = -1 being on the bottom
      tempV.project(camera);

      // convert the normalized position to CSS coordinates
      const x = (tempV.x *  .5 + .5) * w;
      const y = (tempV.y * -.5 + .5) * h;
      return new THREE.Vector2(x, y)
    },
    redraw: function(){
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.beginPath();
      this.ctx.lineWidth = "2";
      this.ctx.strokeStyle = "white";
      this.ctx.rect(this.topLeft.x * this.pixelRatio, this.topLeft.y * this.pixelRatio, this.width * this.pixelRatio, this.height * this.pixelRatio);
      this.ctx.stroke();
    }
  },
  mounted: function(){
    this.canvas = document.getElementById('rect-canvas');
    this.canvas.width = window.innerWidth * this.pixelRatio;
    this.canvas.height = window.innerHeight * this.pixelRatio;

    this.ctx = this.canvas.getContext('2d');
    this.dummyObject = new THREE.Mesh( new THREE.BoxGeometry( 0.001, 0.001, 0.001 ), new THREE.MeshBasicMaterial( {color: 0x000000} ) )
    this.scene.add(this.dummyObject)
    if(this.factIndex>0 && rects[this.factIndex-1].length>1){
      this.update();
      this.redraw()
    }
  }
}
</script>
<style lang="scss">

#rect-area{
  position:fixed;
  top:0px;
  left:0px;
  width:100vw;
  height:100vh;
  z-index:1;
  canvas{
    width:100%;
    height:100%;
    transition: opacity 0.3s ease;
  }
}
</style>
